import { useRouter } from "next/router";
import TabContainer from "../../../dynamicTab";
import ArzPayment from "./arzPayment";
import RamzArzPayment from "./ramArzPayment";
import RiyalPayment from "./riyalPayment";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import EuroIcon from "@mui/icons-material/Euro";
import PaymentsIcon from "@mui/icons-material/Payments";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  icon: {
    fontSize: "30px !important",
  },
}));
const NewIntroSection = ({ globalProps2 }) => {
  console.log(globalProps2);
  const router = useRouter();
  const clasess = useStyles();

  const tabs = [
    {
      label: "پرداخت ریالی",
      path: `/payment-methods/${router.query.id}/${router.query.slug}?tab=rial`,
      icon: <PaymentsIcon className={clasess.icon} />,
      component: () => globalProps2.has_wallet ?  <RiyalPayment /> : <></>,
      disabled: !(globalProps2?.has_online_payment && globalProps2.has_wallet),
    },
    {
      label: "پرداخت ارزی",
      path: `/payment-methods/${router.query.id}/${router.query.slug}?tab=arz`,
      icon: <EuroIcon className={clasess.icon} />,
      component: () => <ArzPayment />,
      disabled: !globalProps2?.has_currency_payment,
    },
    {
      label: "پرداخت رمزارزی",
      path: `/payment-methods/${router.query.id}/${router.query.slug}?tab=ramzarz`,
      icon: <CurrencyBitcoinIcon className={clasess.icon} />,
      component: () => <RamzArzPayment />,
      disabled: !globalProps2?.has_crypto_payment,
    },
  ];
  return (
    <>
      <TabContainer tabs={tabs} />
    </>
  );
};

export default NewIntroSection;
